// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__r75uT","description":"PatientConsentPreview_description__ghbjO"};